<template>
  <div class="form_manage">
    <div class="main_title">
      <h1 class="title">
        {{ $t('message["1244"]') }}
      </h1>
      <header-tip />
    </div>
    <tab-title
      :selected="selected"
      :data="tabData"
      @change="onTab"
    />
    <form-manage
      v-if="selected === 'formManageMent' && tabData[1].show"
      :level="level"
      :permissions="permissions"
      @sub="toSubRecord"
    />
    <submit-record
      v-if="selected === 'subRecord' && tabData[0].show"
      :level="level"
      :permissions="permissions"
    />
  </div>
</template>

<script type="text/ecmascript-6">
import tabTitle from './components/Tab'
import headerTip from './components/Tip'
import formManage from './Manage'
import submitRecord from './Submit'
import { mapState, mapActions } from 'vuex'
// level 1:主管；2:组长；0:普通成员；3:负责人/观察员
export default {
  components: {
    tabTitle,
    headerTip,
    formManage,
    submitRecord
  },
  data () {
    return {
      level: 3,
      selected: 'formManageMent',
      tabData: [{
        fieldkey: 'subRecord',
        fieldname: this.$t('message["1168"]'),
        show: false
      }, {
        fieldkey: 'formManageMent',
        fieldname: this.$t('message["56"]'),
        show: false
      }]
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('smart', ['permissions'])
  },
  watch: {
    baseinfo (val) {
      if (!val) return
      if (val) {
        // 判断权限
        // console.log(val)
        const { level, system_role: systemRole, projectname, comname } = val
        this.$route.meta.title = `${this.$t('message["1244"]')}-${projectname}-${comname}`
        let aLeavel = level && level.split(',').map(item => Number(item))
        if ([1, 2].includes(systemRole)) {
          // return '负责人/观察员'
          this.level = 3
        } else if (aLeavel && aLeavel.includes(1)) {
          // return '主管'
          this.level = 1
        } else if (aLeavel && aLeavel.includes(2)) {
          // return '组长'
          this.level = 2
        } else {
          // return '普通'
          this.level = 0
        }
      }
    },
    'permissions': {
      handler (val) {
        if (!val || !Object.keys(val).length) return

        // 根据权限，设置tab项是否展示
        if (!val['form-manager-self'] && !val['form-manager-public'] && !val['form-manager-all']) {
          this.tabData[1].show = false
        } else {
          this.tabData[1].show = true
        }
        if (!val['form-submit-history-self'] && !val['form-submit-history-public'] && !val['form-submit-history-all']) {
          this.tabData[0].show = false
        } else {
          this.tabData[0].show = true
        }
        // 根据权限判断默认展示的tab
        if (this.tabData[1].show === false || this.$route.query.tab === 'subRecord') {
          this.selected = 'subRecord'
          this.$router.push({ query: { tab: 'subRecord', ...this.$route.query } })
        } else {
          this.selected = 'formManageMent'
          this.$router.push({ query: { tab: 'formManageMent', ...this.$route.query } })
        }
      },
      immediate: true,
      deep: true
    }
  },
  async created () {
    await this.getPersonList()
    await this.getUniversalPermissions()
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      const { name } = from
      const { query } = to
      if (name === 'smartIntercept') {
        if (!('tab' in query)) {
          vm.selected = 'formManageMent'
        } else {
          const { tab } = query
          vm.selected = tab
        }
      }
    })
  },
  methods: {
    ...mapActions('smart/manage', ['getPersonList']),
    ...mapActions('smart', ['getUniversalPermissions']),
    onTab (value) {
      this.selected = value
      this.$router.push({ query: { tab: value } })
    },
    toSubRecord (res) {
      const { tab } = res
      this.selected = tab
    }
  }
}
</script>

<style scoped lang="scss">
.form_manage {
  color: #333;
}
.main_title {
  position: relative;
  border-bottom: 1px solid #ebebeb;
  .title {
    display: inline-block;
  }
}
</style>
